import Vue from 'vue';

Vue.prototype.$dt = function (key) {
  const vm = this;
  return key.split('.').reduce((obj, prop) => {
    return obj && obj[prop] !== undefined ? obj[prop] : null;
  }, vm.$i18n.messages[vm.$i18n.locale]) || '';
};


// WEBPACK FOOTER //
// ./src/plugins/i18nUtils.js